import { ButtonProps, ButtonRenderProps } from "sprint-common-web";

import {
    EditFileRecordListingColumnsConfigButton,
    EditFileRecordListingColumnsConfigButtonProps
} from "../config/EditFileRecordListingColumnsConfigButton";
import { FileRecordListingFilters } from "../hooks/useFileRecordListingFilters";
import { ApproveFileRecordNotificationsButton } from "./approve-notifications/ApproveFileRecordNotificationsButton";
import { ClearSelectedFileRecordsButton } from "./clear/ClearSelectedFileRecordsButton";
import { CreateFileRecordButton } from "./create/CreateFileRecordButton";
import { RemoveFileRecordButton } from "./remove/RemoveFileRecordButton";
import { UpdateMultipleFileRecordsStatusButton } from "./update-multiple-status/UpdateMultipleFileRecordsStatusButton";

interface CreateFileRecordListingButtonsProps {
    filters: FileRecordListingFilters;
    setPageSize(pageSize: number): void;
}

type FileRecordListingButtons = ButtonRenderProps<ButtonProps>;

export const createFileRecordListingButtons = (
    props: CreateFileRecordListingButtonsProps
): FileRecordListingButtons[] => {
    const createFileRecordButton: ButtonRenderProps<ButtonProps> = {
        render: CreateFileRecordButton
    };

    const approveFileRecordsNotificationsButton: ButtonRenderProps<ButtonProps> = {
        render: ApproveFileRecordNotificationsButton
    };

    const clearSelectedFileRecordsButton: ButtonRenderProps<ButtonProps> = {
        render: ClearSelectedFileRecordsButton
    };

    const updateMultipleFileRecordsStatusButton: ButtonRenderProps = {
        render: UpdateMultipleFileRecordsStatusButton
    };

    const removeMultipleFileRecordsStatusButton: ButtonRenderProps = {
        render: RemoveFileRecordButton
    };

    const editFileRecordListingConfigButton: ButtonRenderProps<EditFileRecordListingColumnsConfigButtonProps> = {
        render: EditFileRecordListingColumnsConfigButton,
        pageSize: props.filters.pageSize,
        setPageSize: props.setPageSize
    };

    return [
        createFileRecordButton,
        approveFileRecordsNotificationsButton,
        updateMultipleFileRecordsStatusButton,
        removeMultipleFileRecordsStatusButton,
        clearSelectedFileRecordsButton,
        editFileRecordListingConfigButton
    ];
};
